import { privateAxiosIntance } from "../../Config/axios";
import { protectedRoutes } from "../../Config/urls";

export const getStudy = () => {
  try {
    const response = privateAxiosIntance.get(protectedRoutes.case_study);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudyById = (id) => {
  try {
    console.log("ids", id);
    const response = privateAxiosIntance.get(`${protectedRoutes.case_study}`, {
      params: id,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteStudy = (reqBody) => {
  try {
    const response = privateAxiosIntance.delete(
      `${protectedRoutes.case_study}`,
      { data: reqBody },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postStudy = (reqBody) => {
  try {
    const response = privateAxiosIntance.post(
      protectedRoutes.case_study,
      reqBody,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const patchStudy = (reqBody) => {
  try {
    const response = privateAxiosIntance.patch(
      protectedRoutes.case_study,
      reqBody,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
